var _path, _path2, _text, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgServicerequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.6 30.7",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 11.2C38.1 5.3 29.7.5 19.3.5S.5 5.3.5 11.2c0 4.5 4.9 8.3 11.8 9.9l.2 8.4 7.5-7.7c10-.2 18.1-4.9 18.1-10.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 30.7l-.2-9.2C4.6 19.7 0 15.7 0 11.2 0 5 8.7 0 19.3 0 30 0 38.6 5 38.6 11.2c0 6-8.1 10.9-18.4 11.1L12 30.7zM19.3 1C9.2 1 1 5.6 1 11.2c0 4.1 4.6 7.9 11.4 9.4l.4.1.2 7.6 6.8-7h.2c9.7-.2 17.7-4.7 17.7-10.1C37.6 5.6 29.4 1 19.3 1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(23.976 14.704)",
    fill: "#FFF",
    fontFamily: "'Nunito-Regular'",
    fontSize: 13
  }, "!")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.7 8.3h-9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9c.3 0 .5.2.5.5s-.2.5-.5.5zm-3 3h-6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6c.3 0 .5.2.5.5s-.2.5-.5.5zm2 3h-8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.3 0 .5.2.5.5s-.2.5-.5.5z"
  })));
}

export default SvgServicerequest;